export default {
  biographicalInformation: 'biographicalInformation',
  health: 'health',
  housingPreferences: 'housingPreferences',
  sportActivities: 'sportActivities',
  languages: 'languages',
  personal: 'personal',
  teachingCredentials: 'teachingCredentials',
  teachingExperience: 'teachingExperience',
  universitiesColleges: 'universitiesColleges',
  secondarySchools: 'secondarySchools',
  contactInformation: 'contactInformation',
  documents: 'documents',

  isBiographicalInformationLoading: 'isBiographicalInformationLoading',
  isHealthLoading: 'isHealthLoading',
  isHousingPreferencesLoading: 'isHousingPreferencesLoading',
  isSportActivitiesLoading: 'isSportActivitiesLoading',
  isLanguagesLoading: 'isLanguagesLoading',
  isPersonalLoading: 'isPersonalLoading',
  isTeachingCredentialsLoading: 'isTeachingCredentialsLoading',
  isTeachingExperienceLoading: 'isTeachingExperienceLoading',
  isUniversitiesCollegesLoading: 'isUniversitiesCollegesLoading',
  isSecondarySchoolsLoading: 'isSecondarySchoolsLoading',
  isContactInformationLoading: 'isContactInformationLoading',
  isDocumentsLoading: 'isDocumentsLoading'
}


// WEBPACK FOOTER //
// ./src/constants/school-candidate-profile-state-keys.js